export const SentRoomCRTypeLists = [
    { id: 1 , name: 'ส่งห้องให้ CR แล้ว', value: 'Y' },
    { id: 2 , name: 'ยังไม่ส่งห้องให้ CR', value: 'N' }
]

export const TransferTypeLists = [
    { id: 1 , name: 'โอนแล้ว', value: 'Y' },
    { id: 2 , name: 'ยังไม่โอน', value: 'N' }
]

export const RecieveTypeLists = [
    { id: 1 , name: 'การรับมอบทั้งหมด', value: '209,210' },
    { id: 2 , name: 'การรับมอบสมบูรณ์', value: '209' },
    { id: 3 , name: 'การรับมอบแบบมีเงื่อนไข', value: '210' },
    { id: 4 , name: 'ยังไม่รับมอบ', value: '208,0' }
]

export const CheckingTypeLists = [
    { id: 1 , name: 'เข้าตรวจปกติ(ตรวจก่อนทำรายการโอน)', value: '0' },
    { id: 2 , name: 'เข้าตรวจหลังโอน', value: '240' },
    { id: 3 , name: 'ไม่เข้าตรวจ(ประกันตามสัญญา)', value: '242' },
]

export const RecieveUpdateColumnTypeLists = [
    { id: 1 , name: 'ไม่รับมอบ', value: '208' },
    { id: 2 , name: 'การรับมอบสมบูรณ์', value: '209' },
    { id: 3 , name: 'การรับมอบแบบมีเงื่อนไข', value: '210' }
]